import { ChevronRight } from "lucide-react"
import Button from "./Button"

export default function HeroSection() {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 bg-[url('header.jpg')] bg-cover bg-center">
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      {/* Red accent lines */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-red-500/30 to-transparent transform -rotate-1"></div>
        <div className="absolute top-2/3 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-red-500/20 to-transparent transform rotate-1"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            <span className="text-red-500">Connect.</span> <span className="text-white">Compete.</span>{" "}
            <span className="text-red-500">Conquer.</span>
          </h1>
          <p className="text-xl md:text-2xl text-zinc-300 mb-8">
            Find your perfect gaming squad with FragNades' AI-powered matchmaking for Valorant players.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button size="lg" className="bg-red-500 hover:bg-red-600 text-white">
              Get Started
              <ChevronRight className="ml-2 h-4 w-4" />
            </Button>
            <Button size="lg" variant="outline" className="border-red-500 text-red-500 hover:bg-red-500/10">
              How It Works
            </Button>
          </div>
          <div className="mt-12 flex items-center">
            <div className="flex -space-x-2">
              {[1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className="w-10 h-10 rounded-full bg-zinc-700 border-2 border-black flex items-center justify-center text-xs"
                >
                  {i}
                </div>
              ))}
            </div>
            <p className="ml-4 text-zinc-400">
              <span className="text-red-500 font-bold">1,000+</span> gamers already found their squad
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

